import type { OutlinedInputProps } from '@mui/material'
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material'
import { styled } from '@mui/material/styles'
import IcBaselineCancel from '~icons/ic/baseline-cancel'

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  '[type="search"]::-webkit-search-decoration': {
    appearance: 'none',
  },
  '[type="search"]::-webkit-search-cancel-button': {
    appearance: 'none',
  },
}))

type SearchBarProps = {
  onClear?: () => void
  inputProps: OutlinedInputProps
}

export default function ModelSearchBar(props: StyleProps & SearchBarProps) {
  return (
    <div className={props.className}>
      <StyledOutlinedInput
        fullWidth
        size="small"
        endAdornment={
          props.inputProps.value ? (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={e => {
                  props.onClear?.()
                }}
              >
                <IcBaselineCancel className="text-sm" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
        type="search"
        {...props.inputProps}
      />
    </div>
  )
}
